import { Outlet, createFileRoute } from '@tanstack/react-router'
import { useCan } from '#/user/me'
import { ThreadPanel } from '#/components/ask-annwn/thread-panel'
import { ThreadPanelFoldProvider } from '#/components/ask-annwn/thread-panel-fold'

export const Route = createFileRoute('/_authed/accounts/$accountId/ask-annwn')({
  component: AskAnnwnLayout,
})

// Ask Annwn's frame: the reader's threads beside whichever page is open — the
// start page or a conversation.
function AskAnnwnLayout() {
  const { accountId } = Route.useParams()
  const canRead = useCan('annwn:chats:read')
  return (
    <ThreadPanelFoldProvider>
      <div className="flex h-full min-h-0 max-md:flex-col">
        {canRead ? <ThreadPanel accountId={accountId} /> : null}
        <div className="min-h-0 min-w-0 flex-1 overflow-auto">
          <Outlet />
        </div>
      </div>
    </ThreadPanelFoldProvider>
  )
}
